import { BuiltYearCompleted, BuiltYearSelectItems } from '../components/enter-built-year';
import { ReportedFindingsMachineContext } from '../machine/context';

export function EnterBuiltYearScreen() {
    ReportedFindingsMachineContext.useActorRef();

    const isSelectItems = ReportedFindingsMachineContext.useSelector(
        (state) => state.matches({ enterBuiltYear: 'selectItems' })
            || state.matches({ enterBuiltYear: 'enterBuiltYearRequest' })
    );

    const isConfirmed = ReportedFindingsMachineContext.useSelector((state) => state.matches({ enterBuiltYear: 'confirmed' }));

    return (
        <>
            {isSelectItems && <BuiltYearSelectItems />}
            {isConfirmed && <BuiltYearCompleted />}
        </>
    );
}
